import { createContext } from "react";

export type PageContextState = {
  id: string;
  locale: string;
  links: [string, string][];
};

export const PageContext = createContext<PageContextState | null>(null);
